module.exports = __webpack_public_path__ + "static/media/boss-bar-red-05.2e7fa846.png";